export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';

export const setScrollPosition = (route, value) => ({
  type: SET_SCROLL_POSITION,
  route,
  value,
});
